import { useEffect } from 'react';
import { logEvent } from '../../lib/shared/event-logger';

function useIntersectionTracking(selector) {
    useEffect(() => {
        if (!selector) return;

        const elements = document.querySelectorAll(selector);

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    logEvent(entry.target.id);
                    observer.unobserve(entry.target);
                }
            });
        }, { rootMargin: '0px 0px 0px 0px' });

        elements.forEach(element => observer.observe(element));

        return () => observer.disconnect();
    }, [selector]);
}

export {
    useIntersectionTracking
};
